import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetCrecaAccountsRequestModel, GetCrecaAccountsResponseModel } from "@/features/accounts/creca/services/get-accounts-model";

export class GetCrecaAccountsApi {
  /**
   * クレカ一覧取得API
   */
  public getCrecaAccounts = async (
    param: GetCrecaAccountsRequestModel
  ): Promise<GetCrecaAccountsResponseModel[]> => {
    const path = `/api/crecaaccounts/crecas`;
    const res = await ApiClient.instance.get<GetCrecaAccountsResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
